import { defineMessages, useIntl } from "react-intl";

import type { TravellerType } from "@/features/trips/types/types";

const labelMap = defineMessages({
  adultInDoubleRoom: {
    id: "trips.travellersSelection.adultInDoubleRoom.title",
  },
  adultInSingleRoom: {
    id: "trips.travellersSelection.adultInSingleRoom.title",
  },
  childWithBed: { id: "trips.travellersSelection.childWithBed.title" },
  childWithoutBed: { id: "trips.travellersSelection.childWithoutBed.title" },
  infant: { id: "trips.travellersSelection.infant.title" },
});

type Props = {
  rooms: Record<TravellerType, number>;
};

export function RoomList({ rooms }: Props) {
  const intl = useIntl();

  return (
    <ul className="space-y-1 text-sm font-medium text-text-primary">
      {Object.entries(rooms).map(([travellerType, count]) => {
        if (count === 0) return null;

        return (
          <li key={travellerType} className="text-sm">
            {count}x{" "}
            {intl.formatMessage(labelMap[travellerType as TravellerType])}
          </li>
        );
      })}
    </ul>
  );
}
